module.exports = __webpack_public_path__ + "img/Gouraud_viridis.91085636.png";